import { Link, useLocation } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";

export const Header = () => {
  const loc = useLocation();
  const { t, lang, setLang } = useLang();
  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 mix-blend-difference"
      data-testid="site-header"
    >
      <div className="flex items-center justify-between py-4 px-6 md:px-12">
        <Link
          to="/"
          className="font-display font-extrabold uppercase tracking-tighter text-white text-lg md:text-xl leading-none"
          data-testid="logo-link-header"
        >
          Shame.today
        </Link>
        <nav className="flex items-center gap-6 font-mono text-xs uppercase tracking-[0.2em] text-white">
          <Link
            to="/"
            className={`transition-opacity hover:opacity-60 ${loc.pathname === "/" ? "underline underline-offset-4" : ""}`}
            data-testid="nav-catalog"
          >
            {t("nav.catalog")}
          </Link>
          <div className="flex items-center gap-1" data-testid="lang-toggle">
            <button
              onClick={() => setLang("ru")}
              className={`transition-opacity hover:opacity-60 ${lang === "ru" ? "underline underline-offset-4" : "opacity-50"}`}
              data-testid="lang-ru"
            >
              RU
            </button>
            <span className="opacity-40">/</span>
            <button
              onClick={() => setLang("en")}
              className={`transition-opacity hover:opacity-60 ${lang === "en" ? "underline underline-offset-4" : "opacity-50"}`}
              data-testid="lang-en"
            >
              EN
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
};
